module.exports = __webpack_public_path__ + "img/fakeTemps.63512c2e.png";